import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  InputType,
  ValidationRule,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_123_add_customer: any[] = [
  {
      "componentType": "screenGroup",
      "title": "Customers",
      "screenId": "123",
      "style": {},
      "childComponents": [
          {
              "componentType": "form",
              "Name": "Customer_Add",
              "TableName": "customer_details",
               "Plugins": [{ "type": "api" }],
              "columnNumber": "m1 t1 w3",
              "style": {
                  "padding": 10,
                  "backgroundColor": "#ffffff",
                  "direction": "column"
              },
              "Fields": [
                  {
                      "componentType": "textField",
                      "name": "txt_code_number",
                      "BindValue": "txt_code_number",
                      "Label": "Code",
                      "IncludeLabel": true,
                      "PlaceHolder": "Will be auto generated...",
                      "IsMandatory": false,
                      "inputType": "text",
                      "IsReadOnly": true,
                      "Json_Attribute": "code_no",
                      "AutoPopulate": true,
                      "AutoPopulate_format": "CUST_[******]"
                  },
                  {
                      "componentType": "textField",
                      "name": "txt_customer_name",
                      "BindValue": "txt_customer_name",
                      "Label": "Customer name",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": true,
                      "inputType": "text",
                      "Json_Attribute": "customername",
                      "validation": [
                          {
                              "rule": "required",
                              "message": "Customer name is required"
                          }
                      ]
                  },
                  {
                      "componentType": "searchableDropdown",
                      "name": "s_select_customertype",
                      "BindValue": "s_select_customertype",
                      "Label": "Customer type",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": true,
                      "LookupName": "customer_type",
                      "options": [],
                      "searchable": true,
                      "clearable": true,
                      "Json_Attribute": "customertype"
                  },
                  {
                      "componentType": "textField",
                      "name": "txt_phone",
                      "BindValue": "txt_phone",
                      "Label": "Phone",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": true,
                      "inputType": "phone",
                      "Json_Attribute": "phone",
                      "validation": [
                          {
                              "rule": "pattern",
                              "value": "^[0-9]+$",
                              "message": "Only numbers are allowed"
                          }
                      ]
                  },
                  {
                      "componentType": "textField",
                      "name": "txt_mobile",
                      "BindValue": "txt_mobile",
                      "Label": "Mobile",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": true,
                      "inputType": "phone",
                      "Json_Attribute": "mobile",
                      "validation": [
                          {
                              "rule": "pattern",
                              "value": "^[0-9]+$",
                              "message": "Only numbers are allowed"
                          }
                      ]
                  },
                  {
                      "componentType": "textField",
                      "name": "txt_email",
                      "BindValue": "txt_email",
                      "Label": "Email",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": false,
                      "inputType": "text",
                      "Json_Attribute": "email",
                      "validation": [
                          {
                              "rule": "pattern",
                              "value": "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
                              "message": "Invalid email format"
                          }
                      ]
                  },
                  {
                      "componentType": "textField",
                      "name": "txt_contact_person",
                      "BindValue": "txt_contact_person",
                      "Label": "Contact person",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": false,
                      "inputType": "text",
                      "Json_Attribute": "contact_person"
                  },
                  {
                      "componentType": "textField",
                      "name": "txt_web",
                      "BindValue": "txt_web",
                      "Label": "Web",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": false,
                      "inputType": "url",
                      "Json_Attribute": "web",
                      "validation": [
                          {
                              "rule": "pattern",
                              "value": "^(https?:\\/\\/)?([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}(/.*)?$",
                              "message": "Invalid URL format"
                          }
                      ]
                  },
                  {
                      "componentType": "textField",
                      "name": "txt_address",
                      "BindValue": "txt_address",
                      "Label": "Address",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": true,
                      "inputType": "text",
                      "Json_Attribute": "address"
                  },
                  {
                      "componentType": "textField",
                      "name": "txt_trn",
                      "BindValue": "txt_trn",
                      "Label": "TRN No.",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": false,
                      "inputType": "text",
                      "Json_Attribute": "trn_no"
                  },
                  {
                      "componentType": "selectDropdown",
                      "name": "s_search_country",
                      "BindValue": "s_search_country",
                      "Label": "Country",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": false,
                      "LookupName": "country",
                      "options": [],
                      "Json_Attribute": "country"
                  },
                  {
                      "componentType": "searchableDropdown",
                      "name": "s_search_states",
                      "BindValue": "s_search_states",
                      "Label": "Emirates/State",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": false,
                      "LookupName": "state",
                      "parentField": "s_search_country",
                      "options": [],
                      "searchable": true,
                      "clearable": true,
                      "Json_Attribute": "states"
                  },
                  {
                      "componentType": "searchableDropdown",
                      "name": "s_search_location",
                      "BindValue": "s_search_location",
                      "Label": "City",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": false,
                      "LookupName": "city",
                      "parentField": "s_search_states",
                      "options": [],
                      "searchable": true,
                      "clearable": true,
                      "Json_Attribute": "locationpermission"
                  },
                  {
                      "componentType": "searchableDropdown",
                      "name": "s_search_salesman",
                      "BindValue": "s_search_salesman",
                      "Label": "Salesman",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": true,
                      "LookupName": "salesman_union",
                      "options": [],
                      "searchable": true,
                      "clearable": true,
                      "Json_Attribute": "salesman"
                  },
                  {
                    "componentType": "textField",
                    "name": "grace_period",
                    "BindValue": "grace_period",
                    "Label": "Grace period",
                    "IncludeLabel": true,
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "inputType": "number",
                    "Default_Value": "15",
                    "Json_Attribute": "grace_period",
                    "validation": [
                        {
                            "rule": "pattern",
                            "value": "^(?:0|[1-9][0-9]?|[12][0-9]{2}|3[0-5][0-9]|36[0-5])$",
                            "message": "Value must be between 0 and 365"
                        }
                    ]
                },
                  {
                      "componentType": "textField",
                      "name": "txt_credit_days",
                      "BindValue": "txt_credit_days",
                      "Label": "Credit days",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": false,
                      "inputType": "number",
                      "Json_Attribute": "creditdays",
                      "validation": [
                          {
                              "rule": "pattern",
                              "value": "^(?:0|[1-9][0-9]?|[12][0-9]{2}|3[0-5][0-9]|36[0-5])$",
                              "message": "Value must be between 0 and 365"
                          }
                      ]
                  },
                  {
                      "componentType": "textField",
                      "name": "txt_credit_amount",
                      "BindValue": "txt_credit_amount",
                      "Label": "Credit amount",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": false,
                      "inputType": "number",
                      "Json_Attribute": "creditamount"
                  },
                  {
                      "componentType": "selectDropdown",
                      "name": "customer_lock_status",
                      "BindValue": "customer_lock_status",
                      "Label": "Lock status",
                      "IncludeLabel": true,
                      "PlaceHolder": "",
                      "IsMandatory": false,
                      "options": [
                          { "label": "LOCKED", "value": "locked" },
                          { "label": "UNLOCKED", "value": "unlocked" },
                          { "label": "IDLE", "value": "idle" }
                      ],
                      "defaultValue": "idle",
                      "Json_Attribute": "customer_lock_status"
                  },
                  {
                      "componentType": "files",
                      "name": "file_vat_certificate",
                      "BindValue": "file_vat_certificate",
                      "Label": "VAT certificate",
                      "IncludeLabel": true,
                      "IsMandatory": false,
                      "Json_Attribute": "vat_certificate_attachment",
                      "IsVerticalView": true,
                      "validation": [
                          {
                              "rule": "conditionalRequired",
                              "whenField": "txt_trn",
                              "whenNotEmpty": true,
                              "message": "VAT certificate is required when TRN is provided"
                          }
                      ]
                  },
                  {
                      "componentType": "files",
                      "name": "credit_application_form",
                      "BindValue": "credit_application_form",
                      "Label": "Credit application form",
                      "IncludeLabel": true,
                      "IsMandatory": false,
                      "Json_Attribute": "credit_application_form_attachment",
                      "IsVerticalView": true
                  },
                  {
                      "componentType": "files",
                      "name": "file_trade_license",
                      "BindValue": "file_trade_license",
                      "Label": "Trade license",
                      "IncludeLabel": true,
                      "IsMandatory": false,
                      "Json_Attribute": "trade_license_attachment",
                      "IsVerticalView": true,
                      "validation": [
                          {
                              "rule": "conditionalRequired",
                              "whenField": "s_select_customertype",
                              "whenLabel": "Company",
                              "message": "Trade license is required for Company customers"
                          },
                          {
                              "rule": "conditionalRequired",
                              "whenField": "s_select_customertype",
                              "whenLabel": "Insurance",
                              "message": "Trade license is required for Insurance customers"
                          }
                      ]
                  },
                  {
                      "componentType": "files",
                      "name": "file_others",
                      "BindValue": "file_others",
                      "Label": "Others",
                      "IncludeLabel": true,
                      "IsMandatory": false,
                      "Json_Attribute": "Others_attachment",
                      "IsVerticalView": true
                  }
              ]
          },
          {
              "componentType": "button",
              "name": "Save",
              "onPressAction": "save",
              "style": {
                  "backgroundColor": "#22c55e"
              }
          }
      ]
  }
];
